import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@services/translate/translate.service';
import { Models } from '@ibexfusion/models';
import { ImageAssetsService } from '@services/assets/image-assets.service';
import { EnvironmentService } from '@services/environment/environment.service';
import { DeeplTranslationService } from '@services/deepl-translation/deepl-translation.service';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
    selector: 'ibexsmart-widget',
    templateUrl: './ibexsmart-widget.component.html',
    styleUrls: ['./ibexsmart-widget.component.scss'],
    providers: [ImageAssetsService, DeeplTranslationService],
    standalone: false
})
export class IbexsmartWidgetComponent implements OnChanges {

  @Input() item: any;
  @Input() appItem: any;
  @Input() entrance: any;
  @Input() packageId: any;
  codeEditorOptions = { maxLines: 20, minLines: 10, fontSize: '16px', autoScrollEditorIntoView: false };
  public imageAssetPath: any;
  imagesByPath = {};
  superadmin = false;

  constructor(
    private translate: TranslateService, private imageService: ImageAssetsService, private environmentService: EnvironmentService, private translation: DeeplTranslationService,
    private ms: MessengerService
  ) {
    this.imageAssetPath = this.environmentService.getImageAssetPath();
    this.translate.get('general');
    this.ms.$superadminPrivileges.subscribe(privileges => {
      this.superadmin = !!(privileges || []).find(el => el.privilegeName === 'superadmin' && el.value === 'packages');
    });
  }

  async ngOnChanges() {
    if (!this.item.seasonalImages || !this.item.seasonalImages[0] || !this.item.seasonalImages[0].imagePath) {
      this.setSeasonalImages(this.item)
    }
    if (this.item.tabletWidgetConfig && !this.item.tabletWidgetConfig.seasonalImages) {
      this.setSeasonalImages(this.item.tabletWidgetConfig);
    }
    const paths = this.item.seasonalImages.map(el => el.imagePath);
    const images = await this.imageService.find(0, paths.length, { path: { $in: paths } });
    for (const image of images.data || []) {
      this.imagesByPath[image.path] = image;
    }
  }

  setSeasonalImages(element) {
    if (element.seasonalImages) {
      element.seasonalImages = element.seasonalImages.filter(el => el.imagePath);
      if (element.seasonalImages.length) {
        return;
      }
    }
    element.seasonalImages = element.imagePath ? [this.createNewSeasonalImage(element.imagePath)] : [];
  }

  createNewSeasonalImage(imagePath) {
    const seasonalImage = new Models.PackageInstalledWidgetSeasonalImage();
    seasonalImage.populateFromJSON({ imagePath, from: new Date(new Date().getFullYear(), 0, 1), to: new Date(new Date().getFullYear(), 11, 31) });
    return seasonalImage;
  }

  async translateText(translation, language, field) {
    translation[field] = await this.translation.translate(this.item.translations.find(el => el.language === 'de')[field], language, this.packageId);
  }

  getTitle() {
    return (!!this.item?.translations?.find(el => el.language === 'de')?.title ? this.item?.translations?.find(el => el.language === 'de')?.title : null)
      ?? (this.appItem?.translations?.find(el => el.language === 'de')?.appTitle ?? '');
  }
}
